import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import Euler, { EulerTouchableOpacityProps } from '@euler/components/layout';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { RefObject, memo, useCallback, useRef } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { useTheme } from 'styled-components';

export const OrderSubscriptionButton = memo(
  ({
    subscribed,
    disabled,
    onPress,
    ...props
  }: {
    subscribed?: boolean;
    onPress?: (buttonRef: RefObject<View>) => void;
  } & Omit<EulerTouchableOpacityProps, 'onPress'>) => {
    const ref = useRef<TouchableOpacity>(null);
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    const handlePress = useCallback(() => {
      onPress?.(ref as any);
    }, [onPress]);
    return (
      <Euler.TouchableOpacity
        ref={ref}
        onPress={disabled ? undefined : handlePress}
        activeOpacity={disabled ? 1 : undefined}
        paddingVertical={rpx(8)}
        paddingHorizontal={rpx(15)}
        flexDirection="row"
        alignItems="center"
        flexWrap="nowrap"
        backgroundColor={
          subscribed ? theme.colors.status.success : theme.colors.status.warn
        }
        {...props}
      >
        <Icon
          name="information-outline"
          size={rpx(13)}
          color={'#fff'}
          css={`
            flex-shrink: 0;
          `}
        />
        <Typography.Text
          numberOfLines={1}
          flex={1}
          thin
          size={rpx(12)}
          color="#fff"
          marginHorizontal={rpx(2)}
        >
          {subscribed ? '车主已关注本次服务' : '车主尚未关注本次服务'}
        </Typography.Text>
        <Icon
          name="qrcode"
          size={rpx(13)}
          color="white"
          css={`
            flex-shrink: 0;
          `}
        />
      </Euler.TouchableOpacity>
    );
  },
);
